export default function ConfirmDialog({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Yes',
  immediateClose = false,
}) {
  if (!open) return null;

  const handleConfirm = () => {
    if (immediateClose) {
      onConfirm?.();
      onCancel?.();
      return;
    }
    onConfirm?.();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-lumora-dark-wood/30 backdrop-blur-sm"
      onClick={onCancel}
      role="presentation"
    >
      <div
        className="card max-w-md w-full mx-4 shadow-lift"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
      >
        <h3 id="confirm-dialog-title" className="font-serif text-lg text-lumora-dark-wood mb-2">
          {title}
        </h3>
        <p className="text-lumora-text/60 text-sm mb-6">{message}</p>
        <div className="flex gap-3 justify-end">
          <button type="button" onClick={onCancel} className="btn-secondary">
            Cancel
          </button>
          <button type="button" onClick={handleConfirm} className="btn-primary">
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
